/*
 * Fonte ÚNICA da verdade da marca deste widget (regra: 1 widget = 1 marca).
 *
 * Definida em tempo de build via env `REACT_APP_WIDGET_BRAND`. Para gerar o
 * widget de outra marca (ex.: Betpix), basta trocar esse valor no deploy —
 * nada de marca hardcoded espalhado pelo código.
 *
 * Obs.: este projeto é Create React App (react-scripts), então o prefixo é
 * `REACT_APP_*` (e não `VITE_*`). Só vars com esse prefixo chegam ao bundle.
 */
export const WIDGET_BRAND = (process.env.REACT_APP_WIDGET_BRAND || "vaidebet").trim().toLowerCase();
